import React, { useCallback } from 'react';
import './TaskItem.css';

interface TaskItemProps {
  id: string;
  label: string;
  checked: boolean;
  color: string;
  onToggle: (id: string) => void;
  weekNum?: number;
  isCurrentWeek?: boolean;
  animDelay?: number;
}

export const TaskItem: React.FC<TaskItemProps> = ({
  id, label, checked, color, onToggle, weekNum, isCurrentWeek, animDelay = 0,
}) => {
  const handleClick = useCallback(() => { onToggle(id); }, [id, onToggle]);

  return (
    <button
      className={`task-item ${checked ? 'task-item--checked' : ''} ${isCurrentWeek ? 'task-item--current-week' : ''}`}
      onClick={handleClick}
      style={{ '--task-color': color, '--anim-delay': `${animDelay}ms` } as React.CSSProperties}
      aria-pressed={checked}
    >
      <span className="task-checkbox">
        <svg className="task-check-icon" viewBox="0 0 16 16" width="16" height="16">
          <polyline points="3.5 8 6.5 11 12.5 5" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="task-label">
        {weekNum !== undefined && <span className="task-week-prefix">Wk{weekNum}: </span>}
        {label}
      </span>
      {isCurrentWeek && <span className="task-current-badge">This week</span>}
    </button>
  );
};
